import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Othertimelne from "../Timeline/others_timeline";
import AlbumsCard from "../../Gallary/Albums/AlbumsCards";
import PhotosCard from "../../Gallary/photos/Photo";
import VideosCard from "../../Gallary/Videos/video";
import ProfileBanner from "./ProflieBaner";
import LeftSidebar from "./LeftSidebarColunm";
import BranchManagement from "../Profile/BranchManagement";
import { ProfileGet } from "../../apis/api/ProfileApi";
import { albumGet } from "../../apis/api/GalleryApis";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";
import "../Profile/Profile.css";
import Cookies from "js-cookie";

const OtherProfile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { company_id, userId } = location.state || {};

  const [memberData, setMemberData] = useState(null);
  const [activeTab, setActiveTab] = useState("about");
  const access = JSON.parse(Cookies.get("access") || "{}");

  const profileData = useSelector((state) => state.ProfileSlice.profileData);
  const loading = useSelector((state) => state.ProfileSlice.loading);

  useEffect(() => {
    (async () => {
      try {
        if (userId && company_id) {
          await dispatch(ProfileGet({ userId, company_id }));
          await dispatch(albumGet({ company_id }));
        }
      } catch (error) {
        console.error("Error fetching profile or album data:", error);
      }
    })();
  }, [dispatch, userId, company_id]);

  useEffect(() => {
    if (profileData?.data) {
      setMemberData(profileData.data);
    }
  }, [profileData]);

  const TABS = [
    { key: "about", label: "About", icon: "bx bx-user" },
    { key: "branches", label: "Branches", icon: "bx bx-buildings" },
    { key: "Albums", label: "Albums", icon: "bx bx-images" },
    { key: "Photos", label: "Photos", icon: "bx bx-photo-album" },
    { key: "videos", label: "Videos", icon: "bx bx-video" },
  ];
  const visibleTabs = TABS.filter((t) => t.key === "about" || t.key === "branches" || access.gallery_access === "1");

  return (
    <>
      {loading && <Lodderr />}
      <div className="">
        {memberData ? <ProfileBanner profiledata={memberData} readOnly /> : null}

        <div className="pf-tabs">
          {visibleTabs.map((t) => (
            <motion.button
              key={t.key}
              className={`pf-tab ${activeTab === t.key ? "active" : ""}`}
              onClick={() => setActiveTab(t.key)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.97 }}
              type="button"
            >
              <i className={t.icon}></i>
              {t.label}
            </motion.button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.28 }}
          >
            {activeTab === "about" && (
              <div className="pf-layout">
                <LeftSidebar profileData={profileData} readOnly />
                <div>
                  <Othertimelne profileData={profileData} />
                </div>
              </div>
            )}
            {activeTab === "branches" && (
              <BranchManagement
                readOnly
                company_id={company_id}
                userId={userId}
              />
            )}
            {activeTab === "Albums" && <AlbumsCard />}
            {activeTab === "Photos" && <PhotosCard />}
            {activeTab === "videos" && <VideosCard />}
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
};

export default OtherProfile;
